import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import QuickMenu from "src/components/Shared/QuickMenu";
import TableRow from "src/components/Shared/Table/TableRow";
import TRBody from "src/components/Shared/Table/TRBody";
import { notificationVariants } from "src/helpers/notificationHelper";
import { apiRequest } from "src/async/apiUtils";
import Button from "src/components/Shared/Buttons/Button";
import { classNames } from "src/helpers/classNames";
import { toast } from "react-toastify";
import { formatDate } from "src/helpers/formatDate";
import { ArrowPathIcon } from "@heroicons/react/24/outline";
import BubbleIconList from "src/components/Shared/BubbleIconList";

const NotificationEntry = ({ notification, clients, handleEdit, refreshList, setDeleteId }) => {
  const [loading, setLoading] = useState(false);

  const onToggle = async () => {
    try {
      setLoading(true);
      await apiRequest("PUT", `/notifications/:notification_id`, {
        params: {
          notification_id: notification._id,
        },
        body: {
          ...notification,
          status: !notification.status,
        },
      });
      refreshList();
    } catch (error) {
      setLoading(false);
      toast.error(error?.message);
    }
  };

  useEffect(() => {
    setLoading(false);
  }, [notification.status]);

  const quickMenuItems = [
    {
      name: "Edit",
      onClick: () => handleEdit(notification),
      color: "text-grey-500 hover:text-highlightColor",
    },
    { type: "hr" },
    {
      name: "Delete",
      onClick: () => setDeleteId(notification?._id),
      color: "text-red-500 hover:text-red-600",
    },
  ];

  return (
    <TableRow
      isHoverable
      onClick={() => handleEdit(notification)}
      keyId={notification?._id + "notification"}>
      <TRBody className="max-w-[350px] truncate">{notification?.content}</TRBody>

      <TRBody className="w-[190px] truncate !px-2">
        <BubbleIconList
          data={clients}
          type="client"
          className="!justify-start"
        />
      </TRBody>

      <TRBody className="w-[190px] whitespace-pre-wrap !px-2">
        <div className="flex">
          {(() => {
            const Icon = notification.variant ? notificationVariants[notification.variant].icon : notificationVariants.default.icon;
            return (
              <div
                className="flex items-center gap-2 rounded-md px-3 py-1 font-medium transition-all duration-200 hover:scale-105"
                style={{
                  backgroundColor: notification.background_color,
                  color: notification.text_color,
                }}>
                <Icon className="h-4 w-4 shrink-0" />
                <span className="capitalize">{notification.variant}</span>
              </div>
            );
          })()}
        </div>
      </TRBody>

      <TRBody className="w-[190px] whitespace-pre-wrap !px-0">
        <div onClick={(e) => e.stopPropagation()}>
          <Button
            onClick={onToggle}
            disabled={loading}
            hoverText={loading ? "Updating status..." : `Click to ${notification?.status ? "deactivate" : "activate"} this notification.`}
            version="default"
            className={classNames(
              "flex !h-6 !w-[80px] items-center justify-center gap-2 rounded-full px-2 text-xs font-semibold leading-5 transition-all duration-150",
              loading && "pointer-events-none cursor-wait opacity-70",
              notification?.status ? "bg-green-200 text-green-700" : "bg-gray-100 text-gray-600",
            )}
            aria-busy={loading ? "true" : "false"}>
            {loading ? (
              <>
                <ArrowPathIcon className="h-5 w-5 animate-spin" />
                <span>Saving</span>
              </>
            ) : notification?.status ? (
              "Active"
            ) : (
              "Inactive"
            )}
          </Button>
        </div>
      </TRBody>
      <TRBody className="max-w-44 whitespace-pre-wrap !px-4">
        <div className="hidden text-xs text-gray-900 2xl:block">{formatDate(notification?.created_at, "LLLL")}</div>
        <div className="flex flex-col text-xs text-gray-900 2xl:hidden">
          {formatDate(notification?.created_at, "MM/DD/YYYY")} <span className="text-gray-400">{formatDate(notification?.created_at, "h:mm:ssA")}</span>
        </div>
      </TRBody>
      <TRBody className="relative flex justify-end whitespace-nowrap !py-3 !pl-3 !pr-4 text-sm font-medium sm:!pr-6">
        <div onClick={(e) => e.stopPropagation()}>
          <QuickMenu items={quickMenuItems} />
        </div>
      </TRBody>
    </TableRow>
  );
};

const mapStateToProps = (state) => ({
  me: state.auth.user,
});

export default connect(mapStateToProps, {})(NotificationEntry);
